var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"emd-link",attrs:{"data-testid":"anchor"},on:{"click":function($event){return _vm.copyToClipBoard(_vm.qrCode)}}},[_c('i',{staticClass:"uil uil-copy"}),_vm._v(" "+_vm._s(_vm.$t('pix.clipboardCopy'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }